import { FC, useCallback } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Paper, } from '@mui/material';
import { FieldErrors, useForm, SubmitHandler } from "react-hook-form";
import * as yup from "yup";
import { useYupResolver } from "@util/yup-helper";

// common
import { defs } from "@common/const_defs";
import { ContactUsData } from "@data/contact-us";
import { Z1fmLabelInput } from "@cmpt/molecular/form/Z1fmLabelInput";


const formSchema = yup.object({
  name: yup
    .string()
    .max(120, '最大120桁です')
    .required('必須項目です'),
  email: yup
    .string()
    .email('有効なメールアドレスを入力してください')
    .max(250, '最大250桁です')
    .required('必須項目です'),
  subject: yup
    .string()
    .max(1024, '最大1024桁です'),
  body: yup
    .string()
    .max(4000, '最大4000桁です')
    .required('必須項目です'),
})

type ContactUsFromPanelProps = {
  data: ContactUsData;
  onAction: (act: string, data: ContactUsData) => void
};
const ContactUsFromPanel: FC<ContactUsFromPanelProps> = ({ data, onAction }) => {
  const { control, handleSubmit } =
    useForm<ContactUsData>({
      defaultValues: data,
      // onSubmit modeの場合、formStateのisValidは適切な値とならないことに注意
      mode: "onSubmit",
      resolver: useYupResolver(formSchema),
    });

  const onSubmit: SubmitHandler<ContactUsData> = useCallback(
    (data: ContactUsData) => {
      if (onAction) {
        onAction(defs.kAct_ExecContactUsSend, data);
      }
      //console.log('✅Submitted', data);
    },
    [onAction],
  );

  const onError = useCallback((errors: FieldErrors<ContactUsData>) => {
    // console.log('❌Error', errors);
  }, []);

  return (
    <Paper sx={{ m: 0, p: { xs: 1, sm: 1, md: 2, elevation: 3 } }}>
      <form id="form-contact-us" onSubmit={handleSubmit(onSubmit, onError)}>
        <Grid container spacing={2}>
          <Grid xs={12} sm={12}>
            <Z1fmLabelInput<ContactUsData>
              name="name"
              label="１、お名前"
              control={control}
              config={{
                displayErrorMessage: true,
              }}
              muiProps={{
                textFieldProps: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </Grid>
          <Grid xs={12} sm={12}>
            <Z1fmLabelInput<ContactUsData>
              name="email"
              label="２、メールアドレス"
              control={control}
              config={{
                displayErrorMessage: true,
              }}
              muiProps={{
                textFieldProps: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </Grid>
          <Grid xs={12} sm={12}>
            <Z1fmLabelInput<ContactUsData>
              name="subject"
              label="３、件名"
              control={control}
              config={{
                displayErrorMessage: true,
              }}
              muiProps={{
                textFieldProps: {
                  fullWidth: true,
                  size: "small",
                },
              }}
            />
          </Grid>
          <Grid xs={12} sm={12}>
            <Z1fmLabelInput<ContactUsData>
              name="body"
              label="４、内容"
              control={control}
              config={{
                displayErrorMessage: true,
              }}
              muiProps={{
                textFieldProps: {
                  fullWidth: true,
                  size: "small",
                  multiline: true,
                  rows: 6,
                },
              }}
            />
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default ContactUsFromPanel;